import { useEffect } from "react";

import { useTheme } from "@mui/material";
import { useIntl } from "react-intl";

import { getAppVariant } from "../../../variants/getAppVariant";
import { Variant } from "../../../variants/variants";

const METADATA_KEYS: Record<Variant, { author: string; description: string }> =
  {
    cleverfarm: {
      author: "common.metadata.title",
      description: "common.metadata.description",
    },
    agrotrade: {
      author: "common.metadata.agrotrade.title",
      description: "common.metadata.agrotrade.description",
    },
    mymex: {
      author: "common.metadata.mymex.title",
      description: "common.metadata.mymex.description",
    },
  };

const setFavicon = (href: string): void => {
  const existingLink = document.querySelector(
    "link[rel='icon']",
  ) as HTMLLinkElement | null;

  if (existingLink) {
    existingLink.href = href;
  } else {
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = href;
    document.head.appendChild(link);
  }
};

const setMetaTag = (name: string, content: string): void => {
  const existingMeta = document.querySelector(
    `meta[name='${name}']`,
  ) as HTMLMetaElement | null;

  if (existingMeta) {
    existingMeta.content = content;
  } else {
    const meta = document.createElement("meta");
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  }
};

const Metadata = () => {
  const theme = useTheme();
  const intl = useIntl();
  const variant = getAppVariant();

  useEffect(() => {
    if (theme.assets.favicon) {
      setFavicon(theme.assets.favicon);
    }

    const author = intl.formatMessage({ id: METADATA_KEYS[variant].author });
    const description = intl.formatMessage({
      id: METADATA_KEYS[variant].description,
    });

    setMetaTag("author", author);
    setMetaTag("description", description);
  }, [theme.assets.favicon, intl, variant]);

  return null;
};

export { Metadata };
